import { render, staticRenderFns } from "./termos.vue?vue&type=template&id=e0fc166e&scoped=true"
import script from "./termos.vue?vue&type=script&lang=js"
export * from "./termos.vue?vue&type=script&lang=js"
import style0 from "./termos.vue?vue&type=style&index=0&id=e0fc166e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fc166e",
  null
  
)

export default component.exports